import React, {
  Component, ComponentClass, FunctionComponent,
} from 'react';
import {
  Redirect, Route,
} from 'react-router-dom';

interface Props {
  component: ComponentClass<any> | FunctionComponent<any>;
  fallbackComponent?: ComponentClass<any> | FunctionComponent<any>;
  hasPermission: boolean;
  authFallbackRoute?: string;
  roleFallbackRoute?: string;
  path: string;
  exact?: boolean;
}
class AuthenticationRoute extends Component<Props> {
  render() {
    const {
      component,
      hasPermission,
      authFallbackRoute,
      roleFallbackRoute,
      path,
      fallbackComponent,
      exact,
    } = this.props;
    if (authFallbackRoute !== undefined) {
      if (!hasPermission) {
        return <Redirect to={`/${authFallbackRoute}`} />;
      }
    }
    if (!hasPermission) {
      return <Redirect to={`${roleFallbackRoute}`} />;
    }
    return (
      <Route
        exact={exact}
        path={path}
        component={component}
      />
    );
  }
}

export default AuthenticationRoute;
